import { Component, OnInit } from '@angular/core';
import { EntidadDTO, Tramite } from '../../tramites/models/entidadDTO';
import { TramiteService } from '../../../services/tramite.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-gestion-entidades',
  templateUrl: './gestion-entidades.component.html',
  styleUrl: './gestion-entidades.component.scss',
})
export class GestionEntidadesComponent implements OnInit {
  entidades: EntidadDTO[] = [];
  selectedTramiteId: number | null = null;
  disableMode = false;

  // Multilenguaje
  gestionText: any = {}
  constructor(
    private readonly tramiteService: TramiteService,
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.translate.stream('gestion_entidades').forEach((text) => {
      for (const key of Object.keys(text)) {
        this.gestionText[key] = text[key];
      }
    });
    this.loadData();
  }

  loadData(): void {
    this.tramiteService.listaEntidadesYTramites(false).subscribe(resp => {
      this.entidades = resp;
    });
  }

  toggleSelection(tramite: Tramite): void {
    if (this.selectedTramiteId === tramite.Id) {
      this.selectedTramiteId = null;
      this.disableMode = false;
    } else {
      this.selectedTramiteId = tramite.Id;
      this.disableMode = !tramite.Estado;
    }
  }

  toggleForms(): void {
    if (!this.selectedTramiteId) return;

    const tramite = this.findTramiteById(this.selectedTramiteId);
    if (!tramite) return;

    const updatedState = !tramite.Estado;

    const action = !updatedState ? this.gestionText['deshabilitar'] : this.gestionText['habilitar'];

    this.alertService.confirmacion(
      updatedState
        ? this.gestionText['alerta_habilitar']
        : this.gestionText['alerta_deshabilitar'],
      `${this.gestionText['pregunta_seccionUno']} ${action} ${this.gestionText['pregunta_seccionDos']} ${tramite.Entidad.Entidad}?`,
      () => {
        this.tramiteService
          .actualizarEstadoTramite(this.selectedTramiteId!, updatedState)
          .subscribe({
            next: () => {
              this.alertService.exito(
                `${this.gestionText['formulario']} ${!updatedState ? this.gestionText['deshabilitado'] : this.gestionText['habilitado']} ${this.gestionText['exito']}`
              );
              this.loadData();
              this.selectedTramiteId = null;
              this.disableMode = false;
            },
            error: err => {
              this.alertService.error(
                this.gestionText['error_actualizar']
              );
            },
          });
      },
      () => {
      }
    );
  }

  private findTramiteById(tramiteId: number): Tramite | undefined {
    for (const entidad of this.entidades) {
      const tramite = entidad.Tipo_Tramite.find(t => t.Id === tramiteId);
      if (tramite) return tramite;
    }
    return undefined;
  }
}
